import { useQuery } from '@tanstack/react-query';

import { ServiceRepository } from 'domain/repositories/IServiceRepository';
import { useHookInjection } from 'application/hooks';

export const useCaseGetServiceTypes = () => {
  const { getAllServiceTypes } = useHookInjection<ServiceRepository>(ServiceRepository);

  const { data, isLoading, isFetching } = useQuery({
    queryKey: ['SERVICE_TYPES'] as const,
    queryFn: getAllServiceTypes,
    staleTime: Infinity,
  });

  return {
    ...data,
    isLoading,
    isFetching,
  };
};
